import { render } from "./ArticlesCard.vue?vue&type=template&id=1d24f5fc&scoped=true"
import script from "./ArticlesCard.vue?vue&type=script&lang=js"
export * from "./ArticlesCard.vue?vue&type=script&lang=js"

import "./ArticlesCard.vue?vue&type=style&index=0&id=1d24f5fc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d24f5fc"]])

export default __exports__